import styles from './style.module.scss';
import React, { useState } from 'react';
import { launchToast } from '../../utils';
import { img_logo } from '../../assets';
import { AUTH_API } from '../../api-handle/modules/auth.api';
import { Link } from 'react-router-dom';

/**
 * ForgotPassword component:
 * Standar forgot password component for the application.
 */
export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async () => {
    setIsLoading(true);
    try {
      let res = await AUTH_API.requestForgotPassword(email);
      if (res.status) launchToast.success('Check your email!');
      else throw new Error(res.message);
    } catch (error) {
      launchToast.error(error.message);
    }
    clearFields();
    setIsLoading(false);
  };

  const clearFields = () => {
    setEmail('');
  };

  return (
    <div className={`${styles.Login} h-100vh`}>
      <div className="container h-100 d-flex justify-content-center align-items-center">
        <div
          className="card p-4 py-4 w-100 shadow rounded-15"
          style={{ maxWidth: '450px' }}
        >
          <div className="d-flex justify-content-center align-items-center">
            <img
              src={img_logo}
              alt="logo"
              className="img-fluid mb-5"
              width={200}
            />
          </div>
          <form
            className="w-100 d-flex flex-column justify-content-center align-items-start gap-2"
            onSubmit={(e) => {
              e.preventDefault();
              handleSubmit();
            }}
          >
            <div className="fw-bold">Email</div>
            <input
              type="email"
              className="form-control w-100"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <div className="pt-2 d-flex justify-content-center align-items-center w-100">
              <button
                type="submit"
                className="btn btn-primary px-4 "
                disabled={isLoading}
              >
                {isLoading ? (
                  <div className="spinner-grow text-light small spinner-grow-sm"></div>
                ) : (
                  <div className="fw-bold">Reset Password</div>
                )}
              </button>
            </div>
          </form>
          <br />
          <Link to={'/login'}>
            <div className="link-primary">
              <small className="fw-bold">Back to Login?</small>
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
}
